import { DropdownOption } from '@/shared/types/dropdown';

export const OPTIONS: DropdownOption[] = [
  { label: '5', id: 5, value: 5 },
  { label: '10', id: 10, value: 10 },
  { label: '25', id: 25, value: 25 },
  { label: '50', id: 50, value: 50 },
  { label: '100', id: 100, value: 100 },
];
